import React, { useCallback, useEffect, useState } from "react";

import { Box, Text, Flex, Modal, Loader } from "atoms";
import MemoClose from "assets/icons/Close";
import { api } from "utils/api/api";
import { PROPERTY_PUBLISH_STATUS } from "utils/constants";

export const CommentsModal = ({
  propertyId,
  status,
  onClose,
  icon: { Icon, IconProps, ICprops } = {},
  comment,
}) => {
  const [commentText, setCommentText] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchPropertyCommentHandler = useCallback(async () => {
    try {
      setLoading(true);
      const path = {
        [PROPERTY_PUBLISH_STATUS.unpublished]: `/properties/get/unpublished/${propertyId}`,
        [PROPERTY_PUBLISH_STATUS.revert]: `/properties/get/comments/${propertyId}`,
      }[status?.toLowerCase()];
      const { data } = await api(path);
      setCommentText(data?.data?.slice(-1)?.[0]?.comment || "");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyId]);

  useEffect(() => {
    setCommentText(comment || "");
    propertyId && fetchPropertyCommentHandler();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal isOpen onClose={onClose}>
      <Box minWidth="38.8rem" maxWidth="48.8rem">
        <Box p={{ xs: "2.4rem", lg: "3.2rem" }}>
          <Flex
            justifyContent="space-between"
            borderBottom="0.1rem solid"
            borderColor="neutral.100"
            pb="2.4rem"
          >
            <Text fontSize="2rem" color="primary.900" fontFamily="primaryBold">
              Comments
            </Text>
            <Box
              color="neutral.900"
              onClick={onClose}
              cursor="pointer"
              textAlign="right"
            >
              <MemoClose height="1.6rem" width="1.6rem" />
            </Box>
          </Flex>

          {Icon && (
            <Box mt="2.7rem" textAlign="center" {...ICprops}>
              <Icon height="3.4rem" width="3.4rem" {...IconProps} />
            </Box>
          )}
          <Loader loading={loading}>
            <Text
              mt="2.7rem"
              color="neutral.800"
              fontSize="1.6rem"
              fontFamily="NeometricRegular"
            >
              {commentText || ""}
            </Text>
          </Loader>
        </Box>
      </Box>
    </Modal>
  );
};
